import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap } from 'rxjs/operators';
import { TenantApiService } from '../services/tenant-api.service';
import * as TenantActions from './tenant-store.actions';

@Injectable()
export class TenantEffects {
  fetchTenants$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TenantActions.tenantsRequested),
      switchMap(() => this.tenantService.getAllTenants().pipe(map((response) => TenantActions.tenantsRequestedSuccess({ tenants: response }))))
    )
  );

  constructor(private actions$: Actions, private tenantService: TenantApiService) {}
}
